// Re-export from graphql/ — Zustand-backed compat stub for legacy consumers.
// Real GQL version: hooks/graphql/organizations/useOrganization.ts
import { useOrganizationCompat } from './graphql/organizations/useOrganizationCompat';

export const useOrganization = useOrganizationCompat;
export default useOrganization;
